import React from "react";
import styled from "styled-components";
import { getSurveyStatus, Survey } from '../../../amorg-common';
import { MessageCard } from "../../../designSystem/Message";
import { toDateTimeString } from "../../../utils/date";
import { P } from "../../../designSystem/typography/Body";

const Gray_dark = "rgba(61,61,61,1)";

const StatusContainer = styled.div`
    //border: 1px solid #000;
    /* padding: 20px; */
    text-align: center;
`;

const StatusText = styled.p`
    font-size: 1rem;
    color: ${Gray_dark};
    margin:0px;
`

const StatusSubtext = styled.p`
    font-size: 0.8rem;
    color: ${Gray_dark};
    margin:0px;
`

type SurveyStatusPanelProps = {
    survey: Survey;
}
export function SurveyStatusPanel(props: SurveyStatusPanelProps): JSX.Element {
    const status = getSurveyStatus(props.survey);

    const surveyDate = `(${toDateTimeString(props.survey.start)} - ${toDateTimeString(props.survey.end)})`;

    return (
        <>
            <StatusContainer>

                {status.access === 'waiting' &&
                    <>
                        {status.hasQuestions
                            ? <MessageCard variant="info">Spørgeskemaet venter på at åbne for besvarelser</MessageCard>
                            : <MessageCard variant="warning">Spørgeskemaet venter på at åbne, men kan <u>ikke</u> benyttes da der ikke er oprettet nogen spørgsmål</MessageCard>
                        }
                    </>
                }

                {status.access === 'open' &&
                    <>
                        {status.hasQuestions
                            ?   <MessageCard variant="success">
                                    Spørgeskemaet er åbent for besvarelser
                                    {!status.canEdit &&
                                        <P>Da der er oprettet besvarelser kan visse elementer i spørgeskemaet <u>ikke</u> ændres.</P>
                                    }
                                </MessageCard>
                                
                            :   <MessageCard variant="warning"><StatusText>Spørgeskemaet er åbent, men kan <u>ikke</u> benyttes da der ikke er oprettet nogen spørgsmål</StatusText></MessageCard>
                        }
                    </>
                }

                {status.access === 'closed' &&
                    <>
                        <MessageCard variant="error">
                            Spørgeskemaet er <u>lukket</u> og kan ikke besvares mere
                            <StatusSubtext>{surveyDate}</StatusSubtext>
                        </MessageCard>
                    </>
                }
            </StatusContainer>
        </>
    );
}